<template>
  <div id="LoginSignUpPage"  >
    <div class=" offset-md-3 col-md-6 offset-sm-3 col-sm-6">
      <Alert v-if="error" :text="error" ></Alert>

      <!-- Login Loader -->
      <v-dialog
        v-model="loggingInUser"
        persistent
        width="300"
        >
        <v-card
          color="primary"
          dark
          >
          <v-card-text>
            Please stand by
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- PAbox Logo -->
      <v-layout column align-center justify-center row mt-2 >
          <img  id="logo" src="../../assets/logo_color.svg" />    
      </v-layout>

      <!-- Login Form -->
      <div class="formContainer ">
        <v-container mt-1 mb-2 pb-4 >
          <v-layout column align-center justify-center>
            <span v-if="!forgotPassword" class="display-1 font-weight-regular blue--text text--darken-3">Login</span>
            <span v-if="forgotPassword" class="display-1 font-weight-regular">Forgot Password</span>
          </v-layout>
        </v-container>

        <v-form class="">
          <v-text-field
            v-model="email"
            label="E-mail"
            required
            outlined
          ></v-text-field>

          <v-text-field
            v-model="password"
            :append-icon="e1 ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="() => (e1 = !e1)"
            :type="e1 ? 'password' : 'text'"
            name="input-10-2"
            label="Password"
            hint="At least 6 characters"
            min="6"
            required
            outlined
            v-if="!forgotPassword"
          ></v-text-field>


          <v-layout  mt-3 column align-center>
            <v-btn  @click="login" :ripple="false" v-if="!forgotPassword" style="width:100%" large  color="#D49129" dark>Login</v-btn>
            <v-btn :disabled="forgotPasswordSuccess"  @click.prevent="sendForgetPassword" :dark="!forgotPasswordSuccess" :ripple="false" v-if="forgotPassword" style="width:100%" large  color="green">Reset Password</v-btn>
            <a style="textDecoration: none; marginTop: 10px;" href="" @click.prevent="handleForgotPassword" v-if="!forgotPassword" class="light-blue--text text--darken-4">Forgot Password ?</a>


            <p  v-if="forgotPassword && forgotPasswordError" style="fontSize: 12px" class="mt-3 red--text text-center">{{forgotPasswordError.message}}</p>
            <p  v-if="forgotPassword && forgotPasswordSuccess" style="fontSize: 12px" class="mt-3">
              Please check you inbox for passwrod reset email.
            </p>


            <v-layout row mt-5 pt-3 align-center>
              <span class="title font-weight-light">Don't have an account ?</span>
              <span  @click="showCreateAccountPage"  class=" title ml-1 light-blue--text text--darken-4">Sign Up</span>
            </v-layout>

          </v-layout>
        </v-form>
      </div>

      <v-btn  v-if="!forgotPassword" class="mr-4 ml-2 mt-5 fixed elevation-0" color="red "  dark  fab rounded small @click="back"> <v-icon class="" medium color="white">mdi-arrow-left</v-icon></v-btn>
      <v-btn v-if="forgotPassword" class="mr-4 ml-2 mt-5 fixed elevation-0" color="red "   dark fab  small rounded  @click="handleForgotPassword"> <v-icon class="" medium color="white">mdi-arrow-left</v-icon></v-btn>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: '',
      password: '',
      e1: true,
      forgotPassword: false,
      forgotPasswordSuccess: false,
      forgotPasswordError: null,
      formattedErrorMessage: null,
      loggingInUser: false,
    }
  },
  methods: {
    login() {
      this.loggingInUser = true
      this.$store.dispatch('loginUser', { email: this.email, password: this.password})
      .then(() => {
        this.loggingInUser = false
        if(!this.error) {
          if (this.$route.query.return_to) return this.$router.replace({ path: this.$route.query.return_to })
          this.$router.go(-1)
        }

      })
    },
    handleForgotPassword () {
      this.forgotPassword = !this.forgotPassword
    },
    async sendForgetPassword () {
      if (!this.email) return null
      try {
        this.forgotPasswordError = null
        this.forgotPasswordSuccess = false
        await this.$store.dispatch('forgotPasswordEmail', { email: this.email })
        this.forgotPasswordSuccess = true
      } catch (error) {
        this.forgotPasswordError = error
      }
    },
    showCreateAccountPage () {
      this.$router.push('/signup')
    },
    back() {
      this.$router.go("-1");
    },
  },
  computed: {
    error() {
     let error = this.$store.getters.error
     if(error !== null) {
       if(error.code === 'auth/invalid-email') {
        return error.message = "Please check your email"
      }
      if(error.code === 'auth/user-not-found') {
        return error.message = "No user associated with this email"
      }
      if(error.code === 'auth/wrong-password') {
        return error.message = "Invalid password"
      }
     }

  },
  }

}
</script>

<style scoped>
 .fixed {
    position: fixed;
    bottom: 0;
    right: 0;
    margin-bottom:65px;

  }

  #logo {
    width:70%;
  }
.wrap {
  padding-top:5vh;
}
 
</style>



// WEBPACK FOOTER //
// src/components/User/LoginSignupPage.vue